import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { RadioButton } from 'primereact/radiobutton';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const ApplicationmasterEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		fullname: yup.string().required().label($t('fullname')),
		firstname: yup.string().nullable().label($t('firstname')),
		lastname: yup.string().nullable().label($t('lastname')),
		dob: yup.string().required().label($t('dob')),
		gender: yup.string().required().label($t('gender')),
		additionalname1: yup.string().nullable().label($t('additionalname1')),
		additionalname2: yup.string().nullable().label($t('additionalname2')),
		nationalid: yup.string().required().label($t('nationalid')),
		voterid: yup.string().nullable().label($t('voterid')),
		mobile: yup.string().nullable().label($t('mobile')),
		addrline1: yup.string().nullable().label($t('addrline1')),
		city: yup.string().required().label($t('city')),
		state: yup.string().required().label($t('state')),
		postal: yup.string().required().label($t('postal')),
		maritalstatus: yup.string().required().label($t('maritalstatus')),
		loan_amount: yup.number().nullable().label($t('loanAmount')),
		loan_purpose: yup.number().nullable().label($t('loanPurpose')),
		aadhar_verify: yup.string().required().label($t('aadharVerify')),
		pan_verify: yup.string().nullable().label($t('panVerify')),
		bank_statement_verify: yup.string().nullable().label($t('bankStatementVerify')),
		average_bank_balance: yup.number().nullable().label($t('averageBankBalance')),
		credit_verify: yup.string().nullable().label($t('creditVerify')),
		credit_schore: yup.number().nullable().label($t('creditSchore')),
		credit_eligible: yup.string().nullable().label($t('creditEligible')),
		address_verify: yup.string().nullable().label($t('addressVerify')),
		overall_status: yup.string().nullable().label($t('overallStatus')),
		eligible_loan_amount: yup.number().nullable().label($t('eligibleLoanAmount')),
		interest_rate: yup.number().nullable().label($t('interestRate')),
		tenure: yup.string().nullable().label($t('tenure')),
		processing_fee: yup.number().nullable().label($t('processingFee')),
		emi: yup.number().nullable().label($t('emi')),
		ecs_authorized: yup.string().nullable().label($t('ecsAuthorized')),
		bank_accountnumber: yup.string().nullable().label($t('bankAccountnumber')),
		bank_ifsc: yup.string().nullable().label($t('bankIfsc')),
		middlename: yup.string().nullable().label($t('middlename')),
		pancard: yup.string().nullable().label($t('pancard')),
		userid: yup.number().nullable().label($t('userid')),
		app_date: yup.string().nullable().label($t('appDate'))
	});
	// form default values
	const formDefaultValues = {
		fullname: '', 
		firstname: '', 
		lastname: '', 
		dob: '', 
		gender: '', 
		additionalname1: '', 
		additionalname2: '', 
		nationalid: '', 
		voterid: '', 
		mobile: '', 
		addrline1: '', 
		city: '', 
		state: '', 
		postal: '', 
		maritalstatus: '', 
		loan_amount: '', 
		loan_purpose: '', 
		aadhar_verify: "(N'UnVerified", 
		pan_verify: "(N'UnVerified", 
		bank_statement_verify: "(N'UnVerified", 
		average_bank_balance: '', 
		credit_verify: "(N'UnVerified", 
		credit_schore: '', 
		credit_eligible: '', 
		address_verify: "(N'UnVerified", 
		overall_status: '', 
		eligible_loan_amount: '', 
		interest_rate: '', 
		tenure: '', 
		processing_fee: '', 
		emi: '', 
		ecs_authorized: '', 
		bank_accountnumber: '', 
		bank_ifsc: '', 
		middlename: '', 
		pancard: '', 
		userid: '', 
		app_date: "(getdate())", 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/applicationmaster`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="ApplicationmasterEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('editApplicationmaster')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('fullname')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="fullname"  onChange={formik.handleChange}  value={formik.values.fullname}   label={$t('fullname')} type="text" placeholder={$t('enterFullname')}        className={inputClassName(formik?.errors?.fullname)} />
                                                <ErrorMessage name="fullname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('firstname')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="firstname"  onChange={formik.handleChange}  value={formik.values.firstname}   label={$t('firstname')} type="text" placeholder={$t('enterFirstname')}        className={inputClassName(formik?.errors?.firstname)} />
                                                <ErrorMessage name="firstname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('lastname')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="lastname"  onChange={formik.handleChange}  value={formik.values.lastname}   label={$t('lastname')} type="text" placeholder={$t('enterLastname')}        className={inputClassName(formik?.errors?.lastname)} />
                                                <ErrorMessage name="lastname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('dob')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="dob"  onChange={formik.handleChange}  value={formik.values.dob}   label={$t('dob')} type="text" placeholder={$t('enterDob')}        className={inputClassName(formik?.errors?.dob)} />
                                                <ErrorMessage name="dob" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('gender')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                {
                                                app.menus.gender.map((option) => {
                                                return (
                                                <div key={option.value} className="field-radiobutton">
                                                    <RadioButton inputId={option.value} name="gender" value={option.value} onChange={formik.handleChange}  checked={formik.values.gender === option.value} className={inputClassName(formik?.errors?.gender, '')} />
                                                    <label htmlFor={option.value}>{option.label}</label>
                                                </div>
                                                )
                                                })
                                                }
                                                <ErrorMessage name="gender" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('additionalname1')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="additionalname1"  onChange={formik.handleChange}  value={formik.values.additionalname1}   label={$t('additionalname1')} type="text" placeholder={$t('enterAdditionalname1')}        className={inputClassName(formik?.errors?.additionalname1)} />
                                                <ErrorMessage name="additionalname1" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('additionalname2')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="additionalname2"  onChange={formik.handleChange}  value={formik.values.additionalname2}   label={$t('additionalname2')} type="text" placeholder={$t('enterAdditionalname2')}        className={inputClassName(formik?.errors?.additionalname2)} />
                                                <ErrorMessage name="additionalname2" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('nationalid')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="nationalid"  onChange={formik.handleChange}  value={formik.values.nationalid}   label={$t('nationalid')} type="text" placeholder={$t('enterNationalid')}        className={inputClassName(formik?.errors?.nationalid)} />
                                                <ErrorMessage name="nationalid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('voterid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="voterid"  onChange={formik.handleChange}  value={formik.values.voterid}   label={$t('voterid')} type="text" placeholder={$t('enterVoterid')}        className={inputClassName(formik?.errors?.voterid)} />
                                                <ErrorMessage name="voterid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('mobile')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="mobile"  onChange={formik.handleChange}  value={formik.values.mobile}   label={$t('mobile')} type="text" placeholder={$t('enterMobile')}        className={inputClassName(formik?.errors?.mobile)} />
                                                <ErrorMessage name="mobile" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('addrline1')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="addrline1"  onChange={formik.handleChange}  value={formik.values.addrline1}   label={$t('addrline1')} type="text" placeholder={$t('enterAddrline1')}        className={inputClassName(formik?.errors?.addrline1)} />
                                                <ErrorMessage name="addrline1" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('city')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="city"  onChange={formik.handleChange}  value={formik.values.city}   label={$t('city')} type="text" placeholder={$t('enterCity')}        className={inputClassName(formik?.errors?.city)} />
                                                <ErrorMessage name="city" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('state')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="state"  onChange={formik.handleChange}  value={formik.values.state}   label={$t('state')} type="text" placeholder={$t('enterState')}        className={inputClassName(formik?.errors?.state)} />
                                                <ErrorMessage name="state" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('postal')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="postal"  onChange={formik.handleChange}  value={formik.values.postal}   label={$t('postal')} type="text" placeholder={$t('enterPostal')}        className={inputClassName(formik?.errors?.postal)} />
                                                <ErrorMessage name="postal" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('maritalstatus')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="maritalstatus"  onChange={formik.handleChange}  value={formik.values.maritalstatus}   label={$t('maritalstatus')} type="text" placeholder={$t('enterMaritalstatus')}        className={inputClassName(formik?.errors?.maritalstatus)} />
                                                <ErrorMessage name="maritalstatus" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('loanAmount')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="loan_amount"  onChange={formik.handleChange}  value={formik.values.loan_amount}   label={$t('loanAmount')} type="number" placeholder={$t('enterLoanAmount')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.loan_amount)} />
                                                <ErrorMessage name="loan_amount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('loanPurpose')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="loan_purpose"  onChange={formik.handleChange}  value={formik.values.loan_purpose}   label={$t('loanPurpose')} type="number" placeholder={$t('enterLoanPurpose')}  min={0}  step="any"    className={inputClassName(formik?.errors?.loan_purpose)} />
                                                <ErrorMessage name="loan_purpose" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('aadharVerify')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="aadhar_verify"  onChange={formik.handleChange}  value={formik.values.aadhar_verify}   label={$t('aadharVerify')} type="text" placeholder={$t('enterAadharVerify')}        className={inputClassName(formik?.errors?.aadhar_verify)} />
                                                <ErrorMessage name="aadhar_verify" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('panVerify')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pan_verify"  onChange={formik.handleChange}  value={formik.values.pan_verify}   label={$t('panVerify')} type="text" placeholder={$t('enterPanVerify')}        className={inputClassName(formik?.errors?.pan_verify)} />
                                                <ErrorMessage name="pan_verify" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('bankStatementVerify')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="bank_statement_verify"  onChange={formik.handleChange}  value={formik.values.bank_statement_verify}   label={$t('bankStatementVerify')} type="text" placeholder={$t('enterBankStatementVerify')}        className={inputClassName(formik?.errors?.bank_statement_verify)} />
                                                <ErrorMessage name="bank_statement_verify" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('averageBankBalance')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="average_bank_balance"  onChange={formik.handleChange}  value={formik.values.average_bank_balance}   label={$t('averageBankBalance')} type="number" placeholder={$t('enterAverageBankBalance')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.average_bank_balance)} />
                                                <ErrorMessage name="average_bank_balance" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('creditVerify')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="credit_verify"  onChange={formik.handleChange}  value={formik.values.credit_verify}   label={$t('creditVerify')} type="text" placeholder={$t('enterCreditVerify')}        className={inputClassName(formik?.errors?.credit_verify)} />
                                                <ErrorMessage name="credit_verify" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('creditSchore')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="credit_schore"  onChange={formik.handleChange}  value={formik.values.credit_schore}   label={$t('creditSchore')} type="number" placeholder={$t('enterCreditSchore')}  min={0}  step="any"    className={inputClassName(formik?.errors?.credit_schore)} />
                                                <ErrorMessage name="credit_schore" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('creditEligible')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="credit_eligible"  onChange={formik.handleChange}  value={formik.values.credit_eligible}   label={$t('creditEligible')} type="text" placeholder={$t('enterCreditEligible')}        className={inputClassName(formik?.errors?.credit_eligible)} />
                                                <ErrorMessage name="credit_eligible" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('addressVerify')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="address_verify"  onChange={formik.handleChange}  value={formik.values.address_verify}   label={$t('addressVerify')} type="text" placeholder={$t('enterAddressVerify')}        className={inputClassName(formik?.errors?.address_verify)} />
                                                <ErrorMessage name="address_verify" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('overallStatus')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="overall_status"  onChange={formik.handleChange}  value={formik.values.overall_status}   label={$t('overallStatus')} type="text" placeholder={$t('enterOverallStatus')}        className={inputClassName(formik?.errors?.overall_status)} />
                                                <ErrorMessage name="overall_status" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('eligibleLoanAmount')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="eligible_loan_amount"  onChange={formik.handleChange}  value={formik.values.eligible_loan_amount}   label={$t('eligibleLoanAmount')} type="number" placeholder={$t('enterEligibleLoanAmount')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.eligible_loan_amount)} />
                                                <ErrorMessage name="eligible_loan_amount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('interestRate')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="interest_rate"  onChange={formik.handleChange}  value={formik.values.interest_rate}   label={$t('interestRate')} type="number" placeholder={$t('enterInterestRate')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.interest_rate)} />
                                                <ErrorMessage name="interest_rate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('tenure')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="tenure"  onChange={formik.handleChange}  value={formik.values.tenure}   label={$t('tenure')} type="text" placeholder={$t('enterTenure')}        className={inputClassName(formik?.errors?.tenure)} />
                                                <ErrorMessage name="tenure" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('processingFee')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="processing_fee"  onChange={formik.handleChange}  value={formik.values.processing_fee}   label={$t('processingFee')} type="number" placeholder={$t('enterProcessingFee')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.processing_fee)} />
                                                <ErrorMessage name="processing_fee" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('emi')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="emi"  onChange={formik.handleChange}  value={formik.values.emi}   label={$t('emi')} type="number" placeholder={$t('enterEmi')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.emi)} />
                                                <ErrorMessage name="emi" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('ecsAuthorized')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="ecs_authorized"  onChange={formik.handleChange}  value={formik.values.ecs_authorized}   label={$t('ecsAuthorized')} type="text" placeholder={$t('enterEcsAuthorized')}        className={inputClassName(formik?.errors?.ecs_authorized)} />
                                                <ErrorMessage name="ecs_authorized" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('bankAccountnumber')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="bank_accountnumber"  onChange={formik.handleChange}  value={formik.values.bank_accountnumber}   label={$t('bankAccountnumber')} type="text" placeholder={$t('enterBankAccountnumber')}        className={inputClassName(formik?.errors?.bank_accountnumber)} />
                                                <ErrorMessage name="bank_accountnumber" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('bankIfsc')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="bank_ifsc"  onChange={formik.handleChange}  value={formik.values.bank_ifsc}   label={$t('bankIfsc')} type="text" placeholder={$t('enterBankIfsc')}        className={inputClassName(formik?.errors?.bank_ifsc)} />
                                                <ErrorMessage name="bank_ifsc" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('middlename')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="middlename"  onChange={formik.handleChange}  value={formik.values.middlename}   label={$t('middlename')} type="text" placeholder={$t('enterMiddlename')}        className={inputClassName(formik?.errors?.middlename)} />
                                                <ErrorMessage name="middlename" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('pancard')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pancard"  onChange={formik.handleChange}  value={formik.values.pancard}   label={$t('pancard')} type="text" placeholder={$t('enterPancard')}        className={inputClassName(formik?.errors?.pancard)} />
                                                <ErrorMessage name="pancard" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('userid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="userid"  onChange={formik.handleChange}  value={formik.values.userid}   label={$t('userid')} type="number" placeholder={$t('enterUserid')}  min={0}  step="any"    className={inputClassName(formik?.errors?.userid)} />
                                                <ErrorMessage name="userid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('appDate')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="app_date" showButtonBar className={inputClassName(formik?.errors?.app_date)} dateFormat="yy-mm-dd" value={formik.values.app_date} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="app_date" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label={$t('update')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
ApplicationmasterEditPage.defaultProps = {
	primaryKey: 'applicationid',
	pageName: 'applicationmaster',
	apiPath: 'applicationmaster/edit',
	routeName: 'applicationmasteredit',
	submitButtonLabel: $t('update'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('updateRecord'),
	msgAfterSave: $t('recordUpdatedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default ApplicationmasterEditPage;
